export const money = (cents) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format((cents || 0) / 100);
export const dateTime = (value) => value ? new Intl.DateTimeFormat("tr-TR", { timeZone: "Europe/Istanbul", dateStyle: "short", timeStyle: "medium" }).format(new Date(value)) : "";
export const amountText = (value) => value == null ? "" : (value / 100).toFixed(2).replace(".", ",");
export function csvText(columns, rows) {
  const escape = (value) => {
    let text = String(value ?? "");
    if ((/^[\s]*[=+@-]/.test(text) && !/^-\d+,\d{2}$/.test(text)) || /^[\t\r\n]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  return "\uFEFF" + [columns.map(([label]) => label), ...rows.map((row) => columns.map(([, get]) => get(row)))].map((row) => row.map(escape).join(";")).join("\r\n");
}

export function downloadReport(report, detail) {
  const metadata = [
    ["Başlangıç (TR, dahil)", () => report.period.startDate],
    ["Bitiş (TR, hariç)", () => report.period.endDate],
    ["Rapor zamanı (TR)", () => dateTime(report.generatedAt)],
    ["Rapor türü", () => report.source],
    ["Sürücü ID", (r) => r.driverId],
    ["Sürücü", (r) => r.driverName || r.name],
  ];
  const amounts = [
    ["Tahsilat TRY", (r) => amountText(r.charged)], ["İade TRY", (r) => amountText(r.refunded)],
    ["Ücretli bakiye tahsilat TRY", (r) => amountText(r.paidCharged)], ["Ücretli bakiye iade TRY", (r) => amountText(r.paidRefunded)],
    ["Promosyon tahsilat TRY", (r) => amountText(r.promotionalCharged)], ["Promosyon iade TRY", (r) => amountText(r.promotionalRefunded)],
    ["Komisyon TRY", (r) => amountText(r.commission)],
  ];
  const columns = detail ? [...metadata,
    ["Hareket ID", (r) => r.id], ["Talep/Sipariş ID", (r) => r.reference], ["Kod", (r) => r.code],
    ["Bloke ID", (r) => r.holdId], ["Hizmet", (r) => r.service], ["Güncel talep durumu", (r) => r.currentRequestStatus],
    ["Hareket", (r) => r.type], ["Tarih (TR)", (r) => dateTime(r.occurredAt)], ["İlk tahsilat (TR)", (r) => dateTime(r.originalChargeAt)],
    ["Kayıt tutarı TRY", (r) => amountText(r.amount)], ...amounts,
    ["Mutabakat", (r) => r.issues.length ? "İnceleme gerekli" : "Doğrulandı"], ["Kontrol", (r) => r.issues.join(" | ")],
  ] : [...metadata,
    ["Telefon", (r) => r.phone], ["E-posta", (r) => r.email], ["Fatura tipi", (r) => r.invoiceType],
    ["Fatura unvanı", (r) => r.invoiceName], ["VKN", (r) => r.invoiceVkn], ["TC", (r) => r.tc],
    ["Adres", (r) => r.invoiceAddress], ["Vergi dairesi", (r) => r.invoiceDepartment], ["IBAN", (r) => r.iban],
    ["IBAN sahibi", (r) => r.invoiceIbanName], ["Profil kontrol gerekli", (r) => r.profileNeedsReview ? "Evet" : "Hayır"],
    ...amounts, ["Net ücret TRY", (r) => amountText(r.net)], ["Net ücretli bakiye TRY", (r) => amountText(r.paidNet)],
  ];
  const invoiceRows = report.summaries.filter((row) => row.charged || row.refunded || row.commission);
  const blob = new Blob([csvText(columns, detail ? report.rows : invoiceRows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `surucu-${report.source}-${report.period.startDate}-${report.period.endDate}-${detail ? "hareketler" : "ozet"}.csv`;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
